import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNotificationStateContext } from '../context/NotificationStateContext';

interface NotificationStatusProps {
  showDetails?: boolean;
  className?: string;
}

const NotificationStatus: React.FC<NotificationStatusProps> = ({ 
  showDetails = false, 
  className = '' 
}) => {
  const { isWaiter } = useAuth();
  const { isActive, isLoading } = useNotificationStateContext();

  // Solo mostrar estado de notificaciones para waiters
  if (!isWaiter()) {
    return null;
  }

  if (isLoading) {
    return (
      <div className={`flex items-center space-x-2 text-xs sm:text-sm ${className}`}>
        <div className="w-2 h-2 sm:w-3 sm:h-3 bg-blue-500 rounded-full animate-pulse"></div>
        <span className="text-gray-600">
          <span className="hidden sm:inline">Verificando estado de notificaciones...</span>
          <span className="sm:hidden">Verificando...</span>
        </span>
      </div>
    );
  }

  if (isActive) {
    return (
      <div className={`flex items-center space-x-2 text-xs sm:text-sm ${className}`}>
        <div className="w-2 h-2 sm:w-3 sm:h-3 bg-green-500 rounded-full"></div>
        <span className="text-green-700 font-medium">
          <span className="hidden sm:inline">Notificaciones activas</span>
          <span className="sm:hidden">Activas</span>
        </span>
        {showDetails && (
          <span className="text-gray-500 text-xs hidden sm:inline">
            (Recibirás notificaciones en tiempo real)
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-2 text-xs sm:text-sm ${className}`}>
      <div className="w-2 h-2 sm:w-3 sm:h-3 bg-red-500 rounded-full"></div>
      <span className="text-red-700 font-medium">
        <span className="hidden sm:inline">Notificaciones inactivas</span>
        <span className="sm:hidden">Inactivas</span>
      </span>
      {showDetails && (
        <span className="text-gray-500 text-xs hidden sm:inline">
          (Haz clic en el icono para activar)
        </span>
      )}
    </div>
  );
};

export default NotificationStatus;
